module.exports = __webpack_public_path__ + "static/top_container_certificate-0591e38425e79817307269f64630f7df.svg";